<script setup lang="ts">
import type { KirbyBlock } from "#nuxt-kirby";

const props = defineProps<{
  block?: Record<string, any>;
}>();

interface KirbyImage {
  id: string;
  uuid: string;
  url: string;
  alt: string;
  width?: number;
  height?: number;
}

const page = usePage();

const accordion = ref(
  props.block?.content.accordion?.map((panel: any) => {
    const uuid = panel.image?.[0];
    const resolvedImage = page.value?.images?.find(
      (img: KirbyImage) => img.uuid === uuid,
    );
    return {
      ...panel,
      image: resolvedImage || null,
    };
  }) || [],
);

const toggleOpen = (index: number) => {
  accordion.value = accordion.value.map((panel, i) => ({
    ...panel,
    open: i === index ? !panel.open : false,
  }));
};
</script>
<template>
  <section id="faqCats">
    <div class="faq-item">
      <div class="accordion">
        <AppAccPanel
          v-for="(panel, i) in accordion"
          :key="i"
          :panel="panel"
          :index="i"
          :open="panel.open"
          @toggle-open="toggleOpen"
        />
      </div>
    </div>
  </section>
</template>
